export default function Features() {
  return (
    <section id="features" className="py-32 px-16 bg-[#F5EDE4]">
      <div className="max-w-7xl mx-auto">
        {/* Header */}
        <div className="mb-20">
          <p className="text-sm text-gray-500 mb-4 tracking-widest uppercase">Features</p>
          <h2 className="text-5xl font-bold text-gray-900">맞춤형 인솔의 핵심 기능</h2>
        </div>

        {/* Feature Cards */}
        <div className="grid grid-cols-3 gap-8">
          {/* Card 1 - 발 압력 분석 */}
          <div className="bg-black rounded-3xl p-10 flex flex-col justify-between min-h-[400px] hover:scale-105 transition-transform duration-300">
            <div className="w-16 h-16 rounded-full bg-gray-800 flex items-center justify-center mb-6">
              <i className="ri-pulse-line text-3xl text-white"></i>
            </div>
            <div>
              <h3 className="text-4xl font-bold text-white mb-4">발 압력 분석</h3>
              <p className="text-gray-400 text-base">실시간 압력 분포 측정으로 발의 상태를 정확하게 파악합니다</p>
            </div>
          </div>

          {/* Card 2 - 맞춤 제작 */}
          <div className="relative rounded-3xl overflow-hidden min-h-[400px] hover:scale-105 transition-transform duration-300">
            <img
              src="https://public.readdy.ai/ai/img_res/202a7615167785c82c78c4dc99245398.jpg"
              alt="맞춤 제작"
              className="absolute inset-0 w-full h-full object-cover object-top"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent"></div>
            <div className="relative h-full flex flex-col justify-between p-10">
              <div className="inline-flex items-center gap-3 bg-black/50 backdrop-blur-sm rounded-full px-5 py-3 self-start">
                <i className="ri-scan-line text-xl text-white"></i>
                <span className="text-white font-medium">맞춤 제작</span>
              </div>
              <div>
                <h3 className="text-4xl font-bold text-white">3D 스캔 기반 설계</h3>
              </div>
            </div>
          </div>

          {/* Card 3 - 건강 효과 */}
          <div className="bg-white rounded-3xl p-10 flex flex-col justify-between min-h-[400px] hover:scale-105 transition-transform duration-300">
            <div>
              <h3 className="text-4xl font-bold text-gray-900 mb-4">자세 교정 효과</h3>
              <p className="text-gray-500 text-base mb-8">척추 정렬 개선으로 전신 건강을 증진시킵니다</p>
            </div>
            <div className="flex justify-center">
              <img
                src="https://readdy.ai/api/search-image?query=Minimalist%20illustration%20of%20human%20spine%20alignment%20and%20posture%20correction%2C%20showing%20before%20and%20after%20comparison.%20Clean%20vector%20style%20with%20teal%20and%20coral%20orange%20color%20scheme.%20Simple%20anatomical%20diagram%20demonstrating%20proper%20body%20alignment.%20Modern%20medical%20illustration%20with%20geometric%20shapes%20and%20clean%20lines%20on%20light%20background&width=400&height=300&seq=feature-health-001&orientation=landscape"
                alt="자세 교정"
                className="w-full h-48 object-contain object-top"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
